import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { APIGetResponse } from './types';
import { axiosBaseQuery } from './baseQuery';
import { buildQueryString } from '@libs/helpers/src/QueryHelper';

export const channelGroupsApi = createApi({
  reducerPath: 'channelGroups.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['channelGroups'],
  endpoints: (builder) => ({
    getChannelGroups: builder.query({
      query: (params: any = {}) => ({
        url: `/api/channel-groups?${buildQueryString({ pageNo: 0, pageSize: 99999999 })}`,
      }),
      transformResponse: (response, meta: any): APIGetResponse => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        };
      },
    }),
  }),
  keepUnusedDataFor: 1, // 미사용시 1초간 유지
});

export const { useGetChannelGroupsQuery } = channelGroupsApi;
